import { render, staticRenderFns } from "./UserTip.vue?vue&type=template&id=793daa12&scoped=true&"
import script from "./UserTip.vue?vue&type=script&lang=ts&"
export * from "./UserTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793daa12",
  null
  
)

export default component.exports